var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkThemeDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 777,
    height: 378,
    viewBox: "0 0 777 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5020_29355)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 32.8C23 28.3196 23 26.0794 23.8719 24.3681C24.6389 22.8628 25.8628 21.6389 27.3681 20.8719C29.0794 20 31.3196 20 35.8 20H741.2C745.68 20 747.921 20 749.632 20.8719C751.137 21.6389 752.361 22.8628 753.128 24.3681C754 26.0794 754 28.3196 754 32.8V367.2C754 371.68 754 373.921 753.128 375.632C752.361 377.137 751.137 378.361 749.632 379.128C747.921 380 745.68 380 741.2 380H35.8C31.3196 380 29.0794 380 27.3681 379.128C25.8628 378.361 24.6389 377.137 23.8719 375.632C23 373.921 23 371.68 23 367.2V32.8Z",
    fill: "#171C21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8 20.5H741.2C743.448 20.5 745.105 20.5004 746.414 20.6073C747.717 20.7138 748.632 20.9234 749.405 21.3175C750.816 22.0365 751.964 23.1839 752.683 24.5951C753.077 25.3685 753.286 26.2832 753.393 27.5863C753.5 28.8953 753.5 30.5515 753.5 32.8V367.2C753.5 369.448 753.5 371.105 753.393 372.414C753.286 373.717 753.077 374.632 752.683 375.405C751.964 376.816 750.816 377.964 749.405 378.683C748.632 379.077 747.717 379.286 746.414 379.393C745.105 379.5 743.448 379.5 741.2 379.5H35.8C33.5515 379.5 31.8953 379.5 30.5863 379.393C29.2832 379.286 28.3685 379.077 27.5951 378.683C26.1839 377.964 25.0365 376.816 24.3175 375.405C23.9234 374.632 23.7138 373.717 23.6073 372.414C23.5004 371.105 23.5 369.448 23.5 367.2V32.8C23.5 30.5515 23.5004 28.8953 23.6073 27.5863C23.7138 26.2832 23.9234 25.3685 24.3175 24.5951C25.0365 23.1839 26.1839 22.0365 27.5951 21.3175C28.3685 20.9234 29.2832 20.7138 30.5863 20.6073C31.8953 20.5004 33.5515 20.5 35.8 20.5Z",
    stroke: "#171C21"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 20,
    rx: 3,
    transform: "matrix(-1 0 0 1 730 44)",
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 20,
    rx: 3,
    transform: "matrix(-1 0 0 1 662 44)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.372 52.0909H629.139C629.104 51.1033 628.193 50.3651 626.928 50.3651C625.675 50.3651 624.69 51.0938 624.69 52.1932C624.69 53.0753 625.33 53.5994 626.352 53.8935L627.158 54.1236C627.848 54.3153 628.462 54.5582 628.462 55.2102C628.462 55.9261 627.771 56.3991 626.864 56.3991C626.084 56.3991 625.393 56.054 625.33 55.3125H624.511C624.588 56.3864 625.457 57.1151 626.864 57.1151C628.372 57.1151 629.229 56.2841 629.229 55.223C629.229 53.9957 628.065 53.5994 627.388 53.4205L626.723 53.2415C626.237 53.1136 625.457 52.858 625.457 52.1548C625.457 51.5284 626.033 51.0682 626.902 51.0682C627.695 51.0682 628.295 51.4453 628.372 52.0909ZM632.488 57.1023C633.485 57.1023 634.214 56.6037 634.444 55.8622L633.715 55.6577C633.523 56.169 633.079 56.4247 632.488 56.4247C631.603 56.4247 630.992 55.8526 630.957 54.8011H634.521V54.4815C634.521 52.6534 633.434 52.027 632.411 52.027C631.082 52.027 630.199 53.0753 630.199 54.5838C630.199 56.0923 631.069 57.1023 632.488 57.1023ZM630.957 54.1491C631.008 53.3853 631.548 52.7045 632.411 52.7045C633.229 52.7045 633.753 53.3182 633.753 54.1491H630.957ZM636.422 50.4545H635.668V57H636.422V50.4545ZM638.558 50.4545H637.804V57H638.558V50.4545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.793 57H695.158C696.705 57 697.344 56.2457 697.344 55.2614C697.344 54.2259 696.628 53.6634 696.027 53.625V53.5611C696.589 53.4077 697.088 53.0369 697.088 52.1932C697.088 51.2344 696.449 50.4545 695.081 50.4545H692.793V57ZM693.585 56.2969V54.0213H695.196C696.053 54.0213 696.589 54.5966 696.589 55.2614C696.589 55.8366 696.193 56.2969 695.158 56.2969H693.585ZM693.585 53.331V51.1577H695.081C695.95 51.1577 696.334 51.6179 696.334 52.1932C696.334 52.8835 695.771 53.331 695.055 53.331H693.585ZM701.638 54.9929C701.638 55.9134 700.934 56.3352 700.372 56.3352C699.746 56.3352 699.298 55.875 699.298 55.1591V52.0909H698.544V55.2102C698.544 56.4631 699.209 57.0639 700.129 57.0639C700.871 57.0639 701.356 56.6676 701.586 56.169H701.638V57H702.392V52.0909H701.638V54.9929ZM704.259 58.8409C704.94 58.8409 705.419 58.4798 705.704 57.7159L707.794 52.1037L706.969 52.0909L705.614 56.0028H705.563L704.208 52.0909H703.39L705.205 57.0256L705.065 57.4091C704.79 58.157 704.451 58.2273 703.901 58.0866L703.709 58.7514C703.786 58.7898 704.003 58.8409 704.259 58.8409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 67,
    width: 44,
    height: 6,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 81,
    width: 28,
    height: 6,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 95,
    width: 60,
    height: 6,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 109,
    width: 44,
    height: 6,
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 123,
    width: 36,
    height: 6,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 137,
    width: 15,
    height: 6,
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 157,
    width: 44,
    height: 6,
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 171,
    width: 28,
    height: 6,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 185,
    width: 60,
    height: 6,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 199,
    width: 44,
    height: 6,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 213,
    width: 36,
    height: 6,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 14,
    transform: "matrix(-1 0 0 1 130 241)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 14,
    transform: "matrix(-1 0 0 1 92 241)",
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 14,
    transform: "matrix(-1 0 0 1 103 259)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 14,
    transform: "matrix(-1 0 0 1 92 259)",
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 14,
    transform: "matrix(-1 0 0 1 138 277)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "matrix(-1 0 0 1 92 277)",
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 14,
    transform: "matrix(-1 0 0 1 125 295)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 14,
    transform: "matrix(-1 0 0 1 92 295)",
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 14,
    transform: "matrix(-1 0 0 1 97 313)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14,
    transform: "matrix(-1 0 0 1 92 313)",
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.987 120.536V159.024",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 139.774,
    width: 11.9766,
    height: 17.7636,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.953 114.602V172.333",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.965,
    y: 139.766,
    width: 11.9766,
    height: 31.0864,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.477 302.609V336.656",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.489,
    y: 314.445,
    width: 11.9766,
    height: 10.3621,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.438 283.37V335.181",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.449,
    y: 286.898,
    width: 11.9766,
    height: 22.3728,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.398 261.156V329.25",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 513.411,
    y: 274.48,
    width: 11.9766,
    height: 44.4091,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.275 194.547V252.279",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 577.287,
    y: 213.794,
    width: 11.9766,
    height: 31.0864,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.237 132.362V241.905",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.25,
    y: 148.644,
    width: 11.9766,
    height: 82.897,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.141 166.417V250.794",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 645.153,
    y: 172.343,
    width: 11.9766,
    height: 45.4339,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.062 124.965V234.507",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.074,
    y: 161.473,
    width: 11.9766,
    height: 58.9843,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.012 85V194.542",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 711.023,
    y: 121.509,
    width: 11.9766,
    height: 58.9843,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.883 119.059V176.79",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.896,
    y: 157.546,
    width: 11.9766,
    height: 11.8424,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.811 127.934V210.831",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.823,
    y: 135.327,
    width: 11.9766,
    height: 11.8424,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.742 182.691V240.423",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.754,
    y: 188.609,
    width: 11.9766,
    height: 31.0864,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.662 155.719V252.28",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.675,
    y: 182.703,
    width: 11.9766,
    height: 42.2456,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.621 228.594V271.523",
    stroke: "#0AC67D",
    strokeWidth: 0.667996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.634,
    y: 236,
    width: 11.9766,
    height: 31.0863,
    rx: 1.33599,
    fill: "#0AC67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.482 95.3642V166.419",
    stroke: "#FF5E8E",
    strokeWidth: 0.61959
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9766,
    height: 7.40151,
    rx: 1.23918,
    transform: "matrix(-1 0 0 1 259.906 101.289)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.848 138.277L289.414 187.127",
    stroke: "#FF5E8E",
    strokeWidth: 0.61959
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9766,
    height: 31.0864,
    rx: 1.23918,
    transform: "matrix(-1 0 0 1 295.836 150.121)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.588 237.386L423.154 332.294",
    stroke: "#FF5E8E",
    strokeWidth: 0.61959
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9766,
    height: 62.1727,
    rx: 1.23918,
    transform: "matrix(-1 0 0 1 429.575 258.194)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.555 292.039L439.121 333.91",
    stroke: "#FF5E8E",
    strokeWidth: 0.61959
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9766,
    height: 11.7553,
    rx: 1.23918,
    transform: "matrix(-1 0 0 1 445.542 316.887)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.517 306.45L459.083 335.76",
    stroke: "#FF5E8E",
    strokeWidth: 0.61959
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9766,
    height: 8.22874,
    rx: 1.23918,
    transform: "matrix(-1 0 0 1 465.504 323.864)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.359 228.579L538.925 299.634",
    stroke: "#FF5E8E",
    strokeWidth: 0.61959
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9766,
    height: 39.9682,
    rx: 1.23918,
    transform: "matrix(-1 0 0 1 545.348 240.431)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.32 212.099L558.886 270.972",
    stroke: "#FF5E8E",
    strokeWidth: 0.61959
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9766,
    height: 24.3615,
    rx: 1.23918,
    transform: "matrix(-1 0 0 1 565.309 228.329)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.191 204.695L624.757 263.569",
    stroke: "#FF5E8E",
    strokeWidth: 0.61959
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9766,
    height: 23.6848,
    rx: 1.23918,
    transform: "matrix(-1 0 0 1 631.18 221.199)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.107 116.883L668.673 192.251",
    stroke: "#FF5E8E",
    strokeWidth: 0.61959
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9766,
    height: 29.6061,
    rx: 1.23918,
    transform: "matrix(-1 0 0 1 675.095 148.652)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.777 162.993L325.343 223.116",
    stroke: "#FF5E8E",
    strokeWidth: 0.61959
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9766,
    height: 42.5872,
    rx: 1.23918,
    transform: "matrix(-1 0 0 1 331.765 179.724)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.701 186.113L365.267 268.099",
    stroke: "#FF5E8E",
    strokeWidth: 0.61959
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9766,
    height: 17.7636,
    rx: 1.23918,
    transform: "matrix(-1 0 0 1 371.688 244.864)",
    fill: "#FF5E8E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5020_29355)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 332,
    transform: "translate(160 20)",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 20,
    width: 40,
    height: 350,
    fill: "#1D242A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.141 39.9845H186.712V39.4131H182.141V39.9845Z",
    fill: "#698AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.855 41.7003V46.2718H180.426V41.7003H179.855ZM179.855 33.1289V37.7003H180.426V33.1289H179.855ZM173.569 39.9861H178.141V39.4146H173.569V39.9861Z",
    fill: "#698AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.058 77.6169L184.058 69.6169L183.654 69.2129L175.654 77.2129L176.058 77.6169Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.713 69.4156C185.186 69.4156 185.57 69.0316 185.57 68.5585C185.57 68.0853 185.186 67.7013 184.713 67.7013C184.24 67.7013 183.856 68.0853 183.856 68.5585C183.856 69.0316 184.24 69.4156 184.713 69.4156ZM184.713 69.987C183.924 69.987 183.285 69.3476 183.285 68.5585C183.285 67.7693 183.924 67.1299 184.713 67.1299C185.502 67.1299 186.142 67.7693 186.142 68.5585C186.142 69.3476 185.502 69.987 184.713 69.987ZM174.999 79.1299C175.472 79.1299 175.856 78.7459 175.856 78.2727C175.856 77.7996 175.472 77.4156 174.999 77.4156C174.526 77.4156 174.142 77.7996 174.142 78.2727C174.142 78.7459 174.526 79.1299 174.999 79.1299ZM174.999 79.7013C174.21 79.7013 173.57 79.0619 173.57 78.2727C173.57 77.4836 174.21 76.8442 174.999 76.8442C175.788 76.8442 176.427 77.4836 176.427 78.2727C176.427 79.0619 175.788 79.7013 174.999 79.7013Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5020_29355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.57 102.27H186.142V101.698H173.57V102.27Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.57 109.125H186.142V108.554H173.57V109.125Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.57 105.699H184.713V105.128H173.57V105.699Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 112.556H186.143V111.984H175V112.556Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.856 113.126C174.329 113.126 174.713 112.742 174.713 112.269C174.713 111.796 174.329 111.412 173.856 111.412C173.383 111.412 172.999 111.796 172.999 112.269C172.999 112.742 173.383 113.126 173.856 113.126ZM173.856 113.698C173.067 113.698 172.428 113.058 172.428 112.269C172.428 111.48 173.067 110.841 173.856 110.841C174.645 110.841 175.285 111.48 175.285 112.269C175.285 113.058 174.645 113.698 173.856 113.698ZM185.856 106.269C186.329 106.269 186.713 105.885 186.713 105.412C186.713 104.939 186.329 104.555 185.856 104.555C185.383 104.555 184.999 104.939 184.999 105.412C184.999 105.885 185.383 106.269 185.856 106.269ZM185.856 106.841C185.067 106.841 184.428 106.201 184.428 105.412C184.428 104.623 185.067 103.983 185.856 103.983C186.645 103.983 187.285 104.623 187.285 105.412C187.285 106.201 186.645 106.841 185.856 106.841Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_5020_29355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.878 146.557L173.369 146.069L173.495 145.939C173.598 145.83 173.712 145.705 173.836 145.565C174.19 145.162 174.544 144.72 174.873 144.251C175.435 143.454 175.867 142.665 176.117 141.919C176.823 139.824 179.521 139.225 181.216 141.198C183.074 143.361 181.195 146.558 178.143 146.558H172.879L172.878 146.557ZM178.141 145.986C180.738 145.986 182.297 143.333 180.782 141.57C179.382 139.939 177.225 140.418 176.659 142.102C176.388 142.906 175.931 143.741 175.34 144.58C174.998 145.067 174.631 145.525 174.265 145.942L174.226 145.986H178.142L178.141 145.986Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.245 136.841L181.434 137.576C180.845 138.11 180.82 139.005 181.379 139.564L182.452 140.637C183.01 141.195 183.911 141.182 184.459 140.611L187.688 137.255L187.276 136.859L184.047 140.215C183.719 140.556 183.186 140.563 182.855 140.233L181.783 139.16C181.455 138.832 181.47 138.315 181.818 137.999L182.629 137.264L182.245 136.841H182.245Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.54 172.272L184.742 177.479L185.299 177.35L184.097 172.143L183.54 172.272ZM179.823 175.418L184.183 178.193L184.49 177.711L180.13 174.936L179.823 175.418ZM180.072 174.107L182.822 172.044L182.479 171.587L179.729 173.649L180.072 174.107ZM178.118 175.313L175.42 179.167L175.888 179.495L178.586 175.641L178.118 175.313ZM175.473 179.223L176.793 171.744L176.23 171.645L174.91 179.124L175.473 179.223ZM177.022 171.671L178.162 173.667L178.658 173.383L177.518 171.388L177.022 171.671Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.713 171.411C177.186 171.411 177.57 171.027 177.57 170.554C177.57 170.08 177.186 169.696 176.713 169.696C176.24 169.696 175.856 170.08 175.856 170.554C175.856 171.027 176.24 171.411 176.713 171.411ZM176.713 171.982C175.924 171.982 175.285 171.343 175.285 170.554C175.285 169.764 175.924 169.125 176.713 169.125C177.502 169.125 178.142 169.764 178.142 170.554C178.142 171.343 177.502 171.982 176.713 171.982ZM174.999 181.125C175.472 181.125 175.856 180.741 175.856 180.268C175.856 179.795 175.472 179.411 174.999 179.411C174.526 179.411 174.142 179.795 174.142 180.268C174.142 180.741 174.526 181.125 174.999 181.125ZM174.999 181.696C174.21 181.696 173.57 181.057 173.57 180.268C173.57 179.479 174.21 178.839 174.999 178.839C175.788 178.839 176.427 179.479 176.427 180.268C176.427 181.057 175.788 181.696 174.999 181.696ZM178.999 175.411C179.472 175.411 179.856 175.027 179.856 174.554C179.856 174.08 179.472 173.696 178.999 173.696C178.526 173.696 178.142 174.08 178.142 174.554C178.142 175.027 178.526 175.411 178.999 175.411ZM178.999 175.982C178.21 175.982 177.57 175.343 177.57 174.554C177.57 173.764 178.21 173.125 178.999 173.125C179.788 173.125 180.427 173.764 180.427 174.554C180.427 175.343 179.788 175.982 178.999 175.982ZM183.57 171.982C184.043 171.982 184.427 171.598 184.427 171.125C184.427 170.652 184.043 170.268 183.57 170.268C183.097 170.268 182.713 170.652 182.713 171.125C182.713 171.598 183.097 171.982 183.57 171.982ZM183.57 172.554C182.781 172.554 182.142 171.914 182.142 171.125C182.142 170.336 182.781 169.696 183.57 169.696C184.359 169.696 184.999 170.336 184.999 171.125C184.999 171.914 184.359 172.554 183.57 172.554ZM185.285 179.411C185.758 179.411 186.142 179.027 186.142 178.554C186.142 178.08 185.758 177.696 185.285 177.696C184.811 177.696 184.427 178.08 184.427 178.554C184.427 179.027 184.811 179.411 185.285 179.411ZM185.285 179.982C184.495 179.982 183.856 179.343 183.856 178.554C183.856 177.764 184.495 177.125 185.285 177.125C186.074 177.125 186.713 177.764 186.713 178.554C186.713 179.343 186.074 179.982 185.285 179.982Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.427 204.276C174.199 204.276 173.981 204.366 173.821 204.527C173.66 204.688 173.569 204.906 173.569 205.133C173.569 205.36 173.66 205.578 173.821 205.739C173.981 205.9 174.199 205.99 174.427 205.99C174.654 205.99 174.872 205.9 175.033 205.739C175.193 205.578 175.284 205.36 175.284 205.133C175.284 204.906 175.193 204.688 175.033 204.527C174.872 204.366 174.654 204.276 174.427 204.276ZM172.998 205.133C172.998 204.779 173.129 204.437 173.366 204.174C173.604 203.911 173.931 203.746 174.283 203.71C174.636 203.675 174.989 203.771 175.274 203.982C175.559 204.192 175.756 204.5 175.827 204.847H185.569V205.419H175.827C175.756 205.766 175.559 206.075 175.274 206.285C174.989 206.495 174.636 206.592 174.283 206.556C173.931 206.52 173.604 206.355 173.366 206.092C173.129 205.829 172.998 205.487 172.998 205.133V205.133ZM174.427 209.99C174.199 209.99 173.981 210.081 173.821 210.241C173.66 210.402 173.569 210.62 173.569 210.847C173.569 211.075 173.66 211.293 173.821 211.454C173.981 211.614 174.199 211.705 174.427 211.705C174.654 211.705 174.872 211.614 175.033 211.454C175.193 211.293 175.284 211.075 175.284 210.847C175.284 210.62 175.193 210.402 175.033 210.241C174.872 210.081 174.654 209.99 174.427 209.99ZM172.998 210.847C172.998 210.493 173.129 210.151 173.366 209.888C173.604 209.626 173.931 209.46 174.283 209.425C174.636 209.389 174.989 209.486 175.274 209.696C175.559 209.906 175.756 210.215 175.827 210.562H183.312C183.383 210.215 183.58 209.907 183.865 209.697C184.151 209.487 184.503 209.391 184.856 209.426C185.208 209.462 185.534 209.627 185.772 209.889C186.009 210.152 186.141 210.493 186.141 210.847C186.141 211.201 186.009 211.543 185.772 211.805C185.534 212.068 185.208 212.233 184.856 212.269C184.503 212.304 184.151 212.208 183.865 211.998C183.58 211.788 183.383 211.48 183.312 211.133H175.827C175.756 211.48 175.559 211.789 175.274 211.999C174.989 212.209 174.636 212.306 174.283 212.27C173.931 212.235 173.604 212.069 173.366 211.806C173.129 211.543 172.998 211.202 172.998 210.847V210.847ZM184.712 209.99C184.485 209.99 184.267 210.081 184.106 210.241C183.945 210.402 183.855 210.62 183.855 210.847C183.855 211.075 183.945 211.293 184.106 211.454C184.267 211.614 184.485 211.705 184.712 211.705C184.94 211.705 185.158 211.614 185.318 211.454C185.479 211.293 185.569 211.075 185.569 210.847C185.569 210.62 185.479 210.402 185.318 210.241C185.158 210.081 184.94 209.99 184.712 209.99ZM174.427 213.419C174.199 213.419 173.981 213.509 173.821 213.67C173.66 213.831 173.569 214.049 173.569 214.276C173.569 214.503 173.66 214.721 173.821 214.882C173.981 215.043 174.199 215.133 174.427 215.133C174.654 215.133 174.872 215.043 175.033 214.882C175.193 214.721 175.284 214.503 175.284 214.276C175.284 214.049 175.193 213.831 175.033 213.67C174.872 213.509 174.654 213.419 174.427 213.419ZM172.998 214.276C172.998 213.922 173.129 213.58 173.366 213.317C173.604 213.054 173.931 212.889 174.283 212.853C174.636 212.818 174.989 212.914 175.274 213.124C175.559 213.334 175.756 213.643 175.827 213.99H185.569V214.562H175.827C175.756 214.909 175.559 215.217 175.274 215.428C174.989 215.638 174.636 215.734 174.283 215.699C173.931 215.663 173.604 215.498 173.366 215.235C173.129 214.972 172.998 214.63 172.998 214.276Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.655 206.523L183.861 206.883L183.627 206.363L184.421 206.003L184.655 206.523ZM182.37 207.552L181.575 207.912L181.341 207.392L182.135 207.032L182.37 207.552ZM180.084 208.58L179.284 208.94L179.055 208.42L179.85 208.06L180.084 208.58ZM177.798 209.609L176.998 209.969L176.77 209.449L177.564 209.089L177.798 209.609Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.284 238.27C176.815 238.27 176.427 238.652 176.427 239.127V240.27H176.998V239.127C176.998 238.972 177.13 238.841 177.284 238.841H179.855V247.984H178.712V248.555H181.57V247.984H180.427V238.841H182.998C183.158 238.841 183.284 238.967 183.284 239.127V240.27H183.855V239.127C183.855 238.652 183.472 238.27 182.998 238.27H177.284Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.855 275.129C179.552 275.129 179.261 275.249 179.047 275.464C178.832 275.678 178.712 275.969 178.712 276.272V282.557H175.283V276.272C175.283 273.748 177.331 271.7 179.855 271.7C182.378 271.7 184.426 273.748 184.426 276.272V282.557H180.997V276.272C180.997 275.969 180.877 275.678 180.663 275.464C180.448 275.249 180.158 275.129 179.855 275.129ZM178.14 276.272C178.14 275.817 178.321 275.381 178.642 275.059C178.964 274.738 179.4 274.557 179.855 274.557C180.309 274.557 180.745 274.738 181.067 275.059C181.388 275.381 181.569 275.817 181.569 276.272V281.986H183.855V276.272C183.855 274.064 182.063 272.272 179.855 272.272C177.647 272.272 175.855 274.064 175.855 276.272V281.986H178.14V276.272Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.568 279.7H178.426V280.272H175.568V279.7ZM181.283 279.7H184.14V280.272H181.283V279.7Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.29 314.546C173.129 314.707 173.039 314.925 173.039 315.152C173.039 315.38 173.129 315.598 173.29 315.758L175.512 317.981C175.673 318.142 175.891 318.232 176.118 318.232C176.345 318.232 176.563 318.142 176.724 317.981L186.422 308.283C186.582 308.123 186.673 307.905 186.673 307.677C186.673 307.45 186.582 307.232 186.422 307.071L184.199 304.849C184.039 304.688 183.821 304.598 183.593 304.598C183.366 304.598 183.148 304.688 182.987 304.849L173.29 314.546ZM173.694 314.95L174.906 313.738L175.916 314.748L176.32 314.344L175.31 313.334L176.623 312.021L178.199 313.597L178.603 313.193L177.027 311.617L178.34 310.304L179.351 311.314L179.755 310.91L178.745 309.9L180.058 308.586L181.634 310.162L182.038 309.758L180.462 308.182L181.775 306.869L182.785 307.879L183.189 307.475L182.179 306.465L183.391 305.253C183.445 305.199 183.517 305.169 183.593 305.169C183.669 305.169 183.742 305.199 183.795 305.253L186.018 307.475C186.071 307.529 186.101 307.601 186.101 307.677C186.101 307.753 186.071 307.826 186.018 307.879L176.32 317.577C176.267 317.63 176.194 317.66 176.118 317.66C176.042 317.66 175.97 317.63 175.916 317.577L173.694 315.354C173.64 315.301 173.61 315.228 173.61 315.152C173.61 315.077 173.64 315.004 173.694 314.95V314.95Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.939 347.904L184.225 350.189L184.63 349.785L182.344 347.499L181.939 347.904Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.998 349.41C177.71 349.41 176.474 348.898 175.563 347.987C174.652 347.076 174.141 345.841 174.141 344.552C174.141 343.264 174.652 342.029 175.563 341.118C176.474 340.207 177.71 339.695 178.998 339.695C180.286 339.695 181.521 340.207 182.432 341.118C183.343 342.029 183.855 343.264 183.855 344.552C183.855 345.841 183.343 347.076 182.432 347.987C181.521 348.898 180.286 349.41 178.998 349.41ZM178.998 348.838C180.134 348.838 181.224 348.387 182.028 347.583C182.832 346.779 183.283 345.689 183.283 344.552C183.283 343.416 182.832 342.326 182.028 341.522C181.224 340.718 180.134 340.267 178.998 340.267C177.861 340.267 176.771 340.718 175.967 341.522C175.164 342.326 174.712 343.416 174.712 344.552C174.712 345.689 175.164 346.779 175.967 347.583C176.771 348.387 177.861 348.838 178.998 348.838V348.838Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.998 344.842H180.998V344.271H176.998V344.842Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.284 346.559V342.559H178.713V346.559H179.284Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.244 49C75.2262 49 76.9515 47.1504 76.9515 44.0917C76.9515 41.0473 75.2262 39.2121 72.3443 39.2121H69.0753V49H72.244ZM70.5521 47.7096V40.5025H72.2535C74.3946 40.5025 75.4986 41.7834 75.4986 44.0917C75.4986 46.4097 74.3946 47.7096 72.1627 47.7096H70.5521ZM87.2902 44.1061C87.2902 40.9757 85.4167 39.0783 82.8837 39.0783C80.3412 39.0783 78.4725 40.9757 78.4725 44.1061C78.4725 47.2317 80.3412 49.1338 82.8837 49.1338C85.4167 49.1338 87.2902 47.2365 87.2902 44.1061ZM85.8277 44.1061C85.8277 46.4909 84.566 47.7861 82.8837 47.7861C81.1967 47.7861 79.9397 46.4909 79.9397 44.1061C79.9397 41.7212 81.1967 40.426 82.8837 40.426C84.566 40.426 85.8277 41.7212 85.8277 44.1061ZM88.2413 40.4834H91.2904V49H92.7624V40.4834H95.8164V39.2121H88.2413V40.4834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.563 38.7533H102.287L99.1331 50.472H100.409L103.563 38.7533Z",
    fill: "#818C99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.162 39.2121V45.5303C114.162 46.8589 113.244 47.8147 111.753 47.8147C110.266 47.8147 109.344 46.8589 109.344 45.5303V39.2121H107.867V45.6498C107.867 47.7048 109.406 49.1625 111.753 49.1625C114.099 49.1625 115.643 47.7048 115.643 45.6498V39.2121H114.162ZM123.129 41.7834H124.553C124.51 40.2158 123.124 39.0783 121.136 39.0783C119.171 39.0783 117.666 40.2014 117.666 41.8885C117.666 43.2506 118.641 44.0487 120.213 44.4741L121.37 44.7895C122.417 45.0667 123.224 45.4108 123.224 46.2806C123.224 47.2365 122.311 47.8673 121.054 47.8673C119.917 47.8673 118.971 47.3607 118.885 46.295H117.403C117.499 48.068 118.87 49.1625 121.064 49.1625C123.363 49.1625 124.687 47.9533 124.687 46.295C124.687 44.5314 123.114 43.848 121.872 43.5421L120.916 43.2936C120.151 43.0976 119.133 42.7392 119.138 41.8025C119.138 40.9709 119.898 40.3544 121.102 40.3544C122.225 40.3544 123.023 40.8801 123.129 41.7834ZM129.62 49C132.602 49 134.328 47.1504 134.328 44.0917C134.328 41.0473 132.602 39.2121 129.72 39.2121H126.451V49H129.62ZM127.928 47.7096V40.5025H129.63C131.771 40.5025 132.875 41.7834 132.875 44.0917C132.875 46.4097 131.771 47.7096 129.539 47.7096H127.928ZM135.274 40.4834H138.323V49H139.795V40.4834H142.849V39.2121H135.274V40.4834Z",
    fill: "#818C99"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_5020_29355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9832 47.1215C60.9832 52.4338 56.677 56.7401 51.3647 56.7401C46.0525 56.7401 41.7461 52.4338 41.7461 47.1215C41.7461 41.8093 46.0525 37.5029 51.3647 37.5029C56.677 37.5029 60.9832 41.8093 60.9832 47.1215Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8793 42.3535H46.7715V44.5523H50.226V47.7842H52.4248V44.5523H55.8793V42.3535Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3454 48.1269C48.4877 48.1269 46.1708 47.6746 46.1708 47.1166C46.1708 46.5588 48.4876 46.1064 51.3454 46.1064C54.203 46.1064 56.5198 46.5588 56.5198 47.1166C56.5198 47.6746 54.203 48.1269 51.3454 48.1269ZM57.1554 47.2851C57.1554 46.5656 54.5542 45.9824 51.3454 45.9824C48.1366 45.9824 45.5352 46.5656 45.5352 47.2851C45.5352 47.9186 47.5523 48.4465 50.2252 48.5635V53.2029H52.4238V48.5653C55.1173 48.452 57.1554 47.9219 57.1554 47.2851Z",
    fill: "#464646"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 29,
    width: 19.9375,
    height: 19.9375,
    rx: 9.96875,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7971 32.4932C44.4697 32.5168 46.4943 34.3006 46.8863 36.6716C47.3295 39.3523 45.5104 41.9079 42.833 42.3696C42.4715 42.432 42.1022 42.4564 41.7352 42.4773C40.9915 42.5197 40.2393 43.0233 40.0647 44.0109C40.0146 44.2943 39.9477 44.5747 39.8873 44.8562C39.7995 45.2651 39.453 45.5079 39.0696 45.4304C38.6733 45.3503 38.4442 44.9956 38.53 44.5792C38.6395 44.0469 38.7569 43.5162 38.8709 42.9849C39.2693 41.1277 39.6688 39.2707 40.0654 37.4132C40.1567 36.9855 40.4092 36.752 40.7884 36.7593C41.2087 36.7675 41.5316 37.1553 41.4449 37.5669C41.2372 38.5532 41.0205 39.5375 40.8079 40.5226C40.7668 40.7132 40.729 40.9044 40.6873 41.0949C40.6705 41.1716 40.6838 41.2101 40.7753 41.1998C41.3393 41.1361 41.9047 41.0834 42.4678 41.012C43.9667 40.8218 45.2221 39.6286 45.4931 38.1466C45.8551 36.1674 44.5766 34.3154 42.5951 33.9486C40.6178 33.5825 38.6719 34.9979 38.4073 36.9916C38.3345 37.5404 38.3839 38.0757 38.557 38.6005C38.6909 39.0068 38.5064 39.4098 38.1313 39.529C37.7393 39.6536 37.3596 39.4429 37.2284 39.0281C36.3321 36.1937 37.9839 33.2932 40.8861 32.6219C41.2377 32.5406 41.6034 32.5196 41.7971 32.4932Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3213 44.6089C41.3228 44.144 41.678 43.7902 42.1432 43.79C42.6136 43.7899 42.9782 44.1553 42.9716 44.6202C42.9651 45.0836 42.6057 45.4401 42.1448 45.4404C41.6737 45.4406 41.3198 45.0833 41.3213 44.6089Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 29,
    width: 19.9375,
    height: 19.9375,
    rx: 9.96875,
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0",
    x: 0,
    y: 0,
    width: 777,
    height: 378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5020_29355"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5020_29355",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1",
    x: -78,
    y: -81,
    width: 933,
    height: 562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.98727
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5020_29355"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.11481
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0117778 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5020_29355",
    result: "effect2_dropShadow_5020_29355"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.20625
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.015 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5020_29355",
    result: "effect3_dropShadow_5020_29355"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.0852
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0182222 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_5020_29355",
    result: "effect4_dropShadow_5020_29355"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.5752
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0227778 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_5020_29355",
    result: "effect5_dropShadow_5020_29355"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_5020_29355",
    result: "effect6_dropShadow_5020_29355"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_5020_29355",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5020_29355"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 28C23 23.5817 26.5817 20 31 20H746C750.418 20 754 23.5817 754 28V352H23V28Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5020_29355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 332,
    fill: "white",
    transform: "translate(160 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5020_29355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(171.855 99.4141)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_5020_29355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(171.855 133.414)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_5020_29355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3333,
    height: 19.3333,
    fill: "white",
    transform: "translate(41.667 37.458)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkThemeDesktop);
export default __webpack_public_path__ + "static/media/dark-theme_desktop.215190ddbaec85252863a2dd22e2c153.svg";
export { ForwardRef as ReactComponent };